import BaseModelAPI from '../BaseModelAPI';

export default class ProductionControlTimeList extends BaseModelAPI {

	static entity = 'productioncontroltimelist'
	static entityName = 'productioncontroltime';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
